import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Tabs,
    Tab,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import MainLayout from "./main";
import {TabContext, TabPanel} from "@mui/lab";
import IconButton from "@mui/material/IconButton";
import {
    AddBoxOutlined,
    AddRounded,
    ArrowDownwardOutlined,
    ArrowUpwardOutlined,
    PlusOneRounded, SaveOutlined
} from "@mui/icons-material";
import {
    useGetThemesListForEmployeeQuery,
    useRemoveThemeMutation,
    useSaveThemesMutation
} from "../store/themeplan/themePlanApi";
import copyObject from "../utils/copyObject";
import DeleteIcon from "@mui/icons-material/Delete";

export default function EditThemesPage() {
    const {courseId, disciplineId, virtualGroupId} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [selectedTab, setSelectedTab] = useState('6');
    const {data} = useGetThemesListForEmployeeQuery({courseId, disciplineId, virtualGroupId});
    const [themesToShow, setThemesToShow] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [saveThemes] = useSaveThemesMutation();
    const [availableLessonTypes, setAvailableLessonTypes] = useState([]);
    const [removeThemeRequest] = useRemoveThemeMutation()
    
    useEffect(() => {
        if (data?.themes !== null && data?.themes !== undefined) {
            setAvailableLessonTypes(copyObject(data?.availableLessonTypes ?? []));
            setSelectedTab(data?.availableLessonTypes[0].toString() ?? '6');
            
            if (data?.lessonTypes !== null && data?.lessonTypes !== undefined && data?.lessonTypes.length > 0) {
                setSelectedTab(data?.lessonTypes.sort((l,r) => l > r ? -1 : 1)[0]?.toString());
            }
            
            setThemesToShow(copyObject(data?.themes));
            console.log('themesToShow initialized', data?.themes);
        }
    }, [data]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);
        
        const request = {
            courseId,
            disciplineId,
            virtualGroupId,
            themes: themesToShow
        };
        
        await saveThemes({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                navigate('/journalmain');
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        }).catch(()=>{
            alert('Ошибка');
            setIsSaving(false);
        });
    };
    
    function applyVisualChanges() {
        setRefresh(!refresh);
    }
    
    function handleAddTheme(lessonTypeId) {
        const newTheme = {
            themePlanId: 0,
            theme: '',
            groupFlowBindingId: 0,
            orderNumber: (themesToShow.filter((item) => (item.lessonTypeId === 4 ? 3 : item.lessonTypeId) === lessonTypeId).sort((l,r) => l.orderNumber > r.orderNumber ? -1 : 1)[0]?.orderNumber ?? 0) + 1, // item.lessonType 4 is seminar. Count it as practical
            lessonTypeId
        };
        
        themesToShow.push(newTheme);
        
        applyVisualChanges();
    }
    
    function lessonTypeName(id) {
        switch (id) {
            case 1: return 'Лабораторные';
            case 3: return 'Семинары';
            case 4: return 'Семинары';
            case 6: return 'Лекции';
            default: return '';
        }
    }
    
    function moveTheme(element, index, lessonTypeId, direction) {
        if (index === 0 && direction < 0 || index + direction >= themesToShow.length)
            return;
        
        const themes = themesToShow.filter((item) => item.lessonTypeId === lessonTypeId)
            .sort((l,r) => l.orderNumber > r.orderNumber ? 1 : -1);
        
        const temp = themes[index].orderNumber;
        themes[index].orderNumber = themes[index + direction].orderNumber;
        themes[index + direction].orderNumber = temp;
        applyVisualChanges();
    }
    
    //
    // function moveThemeDown(index) {
    //     if (index + 1 >= request.themes.length)
    //         return;
    //
    //     const copyOfRequest = copyObject(request);
    //     const numberNext = request.themes[index + 1].orderNumber;
    //     const number = request.themes[index].orderNumber;
    //     copyOfRequest.themes[index].orderNumber = numberNext;
    //     // copyOfRequest.themes[index + 1].orderNumber = number;
    //     setRequest(copyOfRequest);
    //     applyVisualChanges();
    // }
    
    async function removeTheme(theme) {
        if (theme.themePlanId <= 0) { // if this theme is not saved
            themesToShow.splice(themesToShow.indexOf(theme), 1);
            applyVisualChanges();
            return;
        }
        
        const request = {
            themePlanId: theme.themePlanId
        };
        
        theme.disabled = true;

        await removeThemeRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                themesToShow.splice(themesToShow.indexOf(theme), 1);
                applyVisualChanges();
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                theme.disabled = false;
            }

            applyVisualChanges();
        }).catch(()=>{
            alert('Ошибка');
            theme.disabled = false;
            applyVisualChanges();
        });
    }

    return (
        <MainLayout>
            <PageTitle title={`Список тем`} />

            <Container>
                <Stack direction="column"
                       padding="30px 0px 0px 0px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Список тем {virtualGroupId > 0 ? 'сводной группы' : ''}
                        </Typography>
                    </Stack>

                    <Card>
                        <TabContext value={selectedTab}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={selectedTab} onChange={(event, newValue) => { setSelectedTab(newValue);}}>
                                    {/* <Tab label="Лекции" value={'6'} /> */}
                                    {/* <Tab label="Семинары" value={'3'}  /> */}
                                    {/* <Tab label="Лабораторные" value={'1'} /> */}
                                    {availableLessonTypes?.sort((l,r) => l > r ? -1 : 1).map((item) => {
                                        return <Tab label={lessonTypeName(item)} value={item.toString()} key={item}/>
                                    })}
                                </Tabs>
                            </Box>
                            {availableLessonTypes?.sort((l,r) => l > r ? -1 : 1).map((lessonTypeId) => {
                                return <TabPanel value={lessonTypeId.toString()} key={lessonTypeId}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell width={10}>#</TableCell>
                                                <TableCell>Тема</TableCell>
                                                <TableCell width={15}>
                                                    <IconButton variant="contained" onClick={()=> handleAddTheme(lessonTypeId)}><AddBoxOutlined /></IconButton>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {themesToShow.filter((themeItem) => themeItem.lessonTypeId === lessonTypeId || themeItem.lessonTypeId === 4 && lessonTypeId === 3)
                                                .sort((l,r) => {
                                                    return l.orderNumber > r.orderNumber ? 1 : -1;
                                                }).map((themeItem, index) => {
                                                    return <TableRow key={index}>
                                                        <TableCell>
                                                            <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                                                <Stack direction={'column'}>
                                                                    <IconButton size={'small'} onClick={() => {moveTheme(themeItem, index, lessonTypeId, -1)}}><ArrowUpwardOutlined fontSize={'smaller'} /></IconButton>
                                                                    <IconButton size={'small'} onClick={() => {moveTheme(themeItem, index, lessonTypeId, 1)}}><ArrowDownwardOutlined fontSize={'smaller'} /></IconButton>
                                                                </Stack>
                                                                <Typography fontSize={25}>{themeItem.orderNumber}</Typography>
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField fullWidth
                                                                       size={'small'}
                                                                       defaultValue={themeItem.theme}
                                                                       value={themeItem.theme}
                                                                       onInput={(event) => {themeItem.theme = event.target.value; applyVisualChanges()}}
                                                                       placeholder={`Тема для занятия №${themeItem.orderNumber}`}/>
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton color={'error'}
                                                                        disabled={themeItem.disabled}
                                                                        onClick={() => {removeTheme(themeItem)}}><DeleteIcon /></IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                })}
                                        </TableBody>
                                    </Table>
                                </TabPanel>
                            })}
                            {/* <TabPanel value={'6'}> */}
                            {/*    {getTabMarkup(6)} */}
                            {/* </TabPanel> */}
                            {/* <TabPanel value={'3'}> */}
                            {/*    {getTabMarkup(3)} */}
                            {/* </TabPanel> */}
                            {/* <TabPanel value={'1'}> */}
                            {/*    {getTabMarkup(1)} */}
                            {/* </TabPanel> */}
                        </TabContext>
                        
                        <Button variant="contained" 
                                fullWidth 
                                disabled={isSaving}
                                startIcon={isSaving ? <CircularProgress size={15}/> : <SaveOutlined />}
                                onClick={handleSave}>Сохранить</Button>
                    </Card>
                    
                    <br />
                </Stack>
            </Container>
        </MainLayout>
    );
}